import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	// This is specifically for the new contentPage media blocks
	const videoSections = document.querySelectorAll('.media .video-wrapper')
	videoSections.forEach(section => {
		let videoWrapper = section.querySelector('.video')
		let video = section.querySelector('video')

		function videoPausePlayHandler(e) {
			if (e.type == 'playing') {
				video.setAttribute('controls', 'controls')
				videoWrapper.classList.remove('paused')
			} else if (e.type == 'pause') {
				if (!video.seeking) {
					video.removeAttribute('controls')
					videoWrapper.classList.add('paused')
				}
			}
		}

		if (videoWrapper && video) {
			videoWrapper.addEventListener('click', e => {
				video.paused ? video.play() : video.pause()
				e.preventDefault()
			})
			videoWrapper.addEventListener('keyup', e => {
				if (e.key === 'Enter') {
					video.paused ? video.play() : video.pause()
					e.preventDefault()
				}
			})

			video.addEventListener('playing', videoPausePlayHandler, false)
			video.addEventListener('pause', videoPausePlayHandler, false)
		}

		let chaptersWrapper = section.querySelector('.chapters')
		let chaptersSlider = section.querySelector('.keen-slider')
		let chapters = section.querySelectorAll('.chapters .chapter')

		chapters.forEach(chapter => {
			chapter.addEventListener('click', () => {
				let time = chapter.dataset.timestamp.split(':')
				let mins = parseInt(time[0])
				let secs = parseInt(time[1])
				video.currentTime = mins * 60 + secs
				video.play()
			})
		})

		if (chaptersSlider) {
			var slider = new KeenSlider(
				chaptersSlider,
				{
					slides: {
						perView: 'auto',
						spacing: 8,
					},
				},
				[
					slider => {
						let arrows = chaptersWrapper.querySelector('.arrows')
						let prevBtn = arrows?.querySelector('button.prev')
						let nextBtn = arrows?.querySelector('button.next')

						prevBtn?.addEventListener('click', () => {
							slider.prev()
						})

						nextBtn?.addEventListener('click', () => {
							slider.next()
						})
					},
				],
			)
		}
	})
})
